import UserProfileContext from '../../context/userprofilecontext.js';

import React, { Fragment, useContext } from 'react';
import PageSkeleton from './pageskeleton.js';


export default function CurrentCaseRequired(props) {
    const userProfileContext = useContext(UserProfileContext);
    const userProfile = userProfileContext.userProfile;
    const hideMessage = props.hideMessage || false;

    // if (!userProfile.currentOrg || !userProfile.currentOrg.orgID) {
    //     if (hideMessage) {
    //         return null;
    //     }
    //     return (<Fragment>You are not currently working in an organization.</Fragment>);
    // }

    if (!userProfile.currentCase || !userProfile.currentCase.caseID) {
        if (hideMessage) {
            return null;
        }
        return (<Fragment>You are not currently working in a case.</Fragment>);
    }

    return (
        <Fragment>
            {props.children}
        </Fragment>
    );
}